








































































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import storeaddressInfo from '@/store/entities/back-storeaddress-list';
import appconst from '@/lib/appconst';

class EditLogistics {
    id: number;
    storeId: number;
    shipment: string;
    userCode: string;
    processTime?: Date;
    receiveStatus: number;
    imageGuid: string;
    reMark: string;
    shelfNumber: string;
    isConfirm: boolean;
    goodsImageGuid: string;
}
@Component
export default class CreateLogisticsModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    logistics: EditLogistics = new EditLogistics();
    warehouseCityId: number = 0;
    storeaddressList: Array<storeaddressInfo> = [];
    isDisplay: string = '';
    imgUrl: string = '';
    selectDate: string = "";
    selectTime: string = "";
    oldReceiveStatus: number;
    isReadOnly = false;
    imgUploadUrl: string = '';
    goodsimgUrl: string = '';
    headers: any = {
        "Authorization": "Bearer " + window.abp.auth.getToken(),
        ".AspNetCore.Culture": window.abp.utils.getCookieValue("Abp.Localization.CultureName"),
        "Abp.TenantId": window.abp.multiTenancy.getTenantIdCookie()
    };
    created() {
        this.imgUploadUrl = appconst.remoteServiceBaseUrl + "api/services/app/Logistics/UploadLogisticsImg";
        this.getData();
    }

    handleSuccess(res, file) {
        if (res.success) {
            this.logistics.imageGuid = res.result;
            var data = { imageGuid: this.logistics.imageGuid, url: null };
            this.$store.commit('backlogistics/getImgUrl', data);
            this.imgUrl = data.url;
        }
    }


    handleError(res, file) {
        this.$Message.error('上传图片失败。' + res.message);
    }


    setImage() {
        if (this.logistics.goodsImageGuid && this.logistics.goodsImageGuid.length > 1) {
            var datas = { goodsImageGuid: this.logistics.goodsImageGuid, urls: null };
            this.$store.commit('backlogistics/getGoodsImgUrl', datas);
            this.goodsimgUrl = datas.urls;
        } else {
            this.goodsimgUrl = null;
        }
    }

    async getData() {
        await this.$store.dispatch({
            type: 'backstoreaddress/getAll',
            data: {}
        })
        //var a = new storeaddressInfo();
        //a.id = null;
        //a.storeName = "全部";
        this.storeaddressList = this.$store.state.backstoreaddress.list.filter(function (item) { return item.whetherEffective == true });
        //this.storeaddressList.push(a);
        this.logistics.storeId = this.storeaddressList[0].id;
    }

    handleSuccessGoods(res, file) {
        if (res.success) {
            this.logistics.goodsImageGuid = res.result;
            this.setImage();
        }
    }
    handleErrorGoods(res, file) {
        this.$Message.error('上传图片失败。' + res.message);
    }



    signFor() {
        this.logistics.receiveStatus = 1;
        this.save();
    }

    j
    save() {
        (this.$refs.logisticsCreateForm as any).validate(async (valid: boolean) => {
            if (valid) {
                if (!this.selectDate || this.selectDate.length == 0) {
                    var anyDate: any = this.selectDate;
                    this.logistics.processTime = anyDate;
                }

                await this.$store.dispatch({
                    type: 'backabroadlogistics/updateLogistics',
                    data: this.logistics
                });
                (this.$refs.logisticsCreateForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
            }
        })
    }

    cancel() {
        (this.$refs.logisticsCreateForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
        }
    }
    logisticsRule = {
        storeId: [
            { required: true, message: '仓库不能为空', trigger: 'change', type: 'number' }
        ],
        shipment: [
            { required: true, max: 30, message: '快递单号不能为空，且长度必须小于30', trigger: 'blur' }
        ],
        userCode: [
            { required: true, max: 30, message: '用户编码不能为空，且长度必须小于30', trigger: 'blur' }
        ],
        reMark: [
            { max: 500, message: '长度不能大于500', trigger: 'blur' }
        ]
    };

}
